import { motion } from "framer-motion";
import { Lightning, Leaf, Recycle, Mountains } from "@phosphor-icons/react";
import { useI18n } from "../lib/i18n";
import { Reveal, Eyebrow, fadeUp } from "../components/Motion";

const IMGS = {
  clean_tech:
    "https://customer-assets.emergentagent.com/job_family-equity-hub/artifacts/32lda9ou_image.png",
  biogas:
    "https://images.unsplash.com/photo-1673208769691-e74104d853fd?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  recycling:
    "https://static.prod-images.emergentagent.com/jobs/1cfd506a-8d58-4dee-aebc-bac5c6ae0bd8/images/8438f6afb400f79a0d8e17138d8d9a7415b8daac32bf69da96a6a7df0bf82582.png",
  natural_resources:
    "https://images.unsplash.com/photo-1448375240586-882707db888b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
};
const ICONS = {
  clean_tech: Lightning,
  biogas: Leaf,
  recycling: Recycle,
  natural_resources: Mountains,
};

export default function Sectors() {
  const { t } = useI18n();
  return (
    <div className="pt-32" data-testid="sectors-page">
      <section className="px-6 md:px-10">
        <div className="max-w-[1400px] mx-auto">
          <Eyebrow>{t.sectors.eyebrow}</Eyebrow>
          <motion.h1
            {...fadeUp}
            className="font-display text-5xl sm:text-6xl lg:text-7xl xl:text-8xl font-light tracking-tighter leading-[1.02] mt-6 max-w-5xl"
          >
            {t.sectors.title}
          </motion.h1>
          <motion.p
            {...fadeUp}
            transition={{ ...fadeUp.transition, delay: 0.1 }}
            className="text-lg sm:text-xl text-[#4A4D4A] mt-8 max-w-2xl leading-relaxed"
          >
            {t.sectors.lead}
          </motion.p>
        </div>
      </section>

      <section className="mt-20 sm:mt-28 px-6 md:px-10">
        <div className="max-w-[1400px] mx-auto space-y-5">
          {t.sectors.list.map((s, i) => {
            const Icon = ICONS[s.key];
            const reverse = i % 2 === 1;
            return (
              <Reveal key={s.key} delay={i * 0.05}>
                <div
                  className={`grid grid-cols-1 md:grid-cols-12 gap-0 bg-white border border-[#EBEAE0] rounded-sm overflow-hidden ${
                    reverse ? "md:[direction:rtl]" : ""
                  }`}
                >
                  <div className="md:col-span-7 [direction:ltr] aspect-[16/9] md:aspect-auto md:min-h-[420px] relative overflow-hidden">
                    <img src={IMGS[s.key]} alt={s.t} className="absolute inset-0 w-full h-full object-cover" />
                  </div>
                  <div className="md:col-span-5 [direction:ltr] p-10 md:p-14 flex flex-col justify-center">
                    <div className="flex items-center gap-3">
                      <Icon size={32} weight="duotone" className="text-[#A6192E]" />
                      <span className="font-mono text-xs text-[#7A7D7A] tracking-wider">
                        SECTOR 0{i + 1}
                      </span>
                    </div>
                    <h2 className="font-display text-3xl sm:text-4xl text-[#1A1A1A] mt-5 tracking-tight">
                      {s.t}
                    </h2>
                    <p className="text-base text-[#4A4D4A] mt-5 leading-relaxed">{s.d}</p>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </section>

      <section className="mt-32 px-6 md:px-10">
        <div className="max-w-[1400px] mx-auto bg-[#1A4331] text-white rounded-sm p-12 sm:p-16 grain relative overflow-hidden">
          <div className="relative z-10">
            <Eyebrow color="red" className="text-[#E0A6A6]">{t.sectors.geoTitle}</Eyebrow>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-light tracking-tighter mt-6">
              Europe. United States. Asia.
            </h2>
            <div className="mt-10 grid grid-cols-3 gap-4 sm:gap-8">
              {["Europe", "United States", "Asia"].map((g) => (
                <div key={g} className="border-t border-white/15 pt-4">
                  <div className="text-xs uppercase tracking-[0.2em] text-white/60">Region</div>
                  <div className="font-display text-xl sm:text-2xl mt-2">{g}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
